import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  imports: [
    FormsModule,
    FontAwesomeModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearchComponent {

  private router = inject(Router);

  faSearch = faSearch;
  searchTerm = '';

  search(): void {
    if (this.searchTerm) {
      if (this.isNumber(this.searchTerm)) {
        this.router.navigateByUrl(`/search/results?term=${this.searchTerm}`);
      } else {
        this.router.navigateByUrl(`/maintenance/publishers?search=${this.searchTerm}`);
      }
    }
  }

  private isNumber(value) {
    // Handle edge cases like null, undefined, or '', which would otherwise evaluate to 0
    if (typeof value !== 'string' || value.trim() === '') {
      return false;
    }

    // If it's not a number, this turns into NaN
    const num = Number(value);
    return Number.isInteger(num);
  }
}
